var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggle-sidebar",attrs:{"type":"button"},on:{"click":_vm.toggleSidebarVisible}},[_c('ion-icon',{attrs:{"name":"menu-outline"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }